<template>
  <Content />
</template>

<script>
import Content from '@/components/content/education/courses/CourseBookContent.vue'

export default {
  name: 'CourseBookContent',
  components: { Content }
}
</script>

<style scoped>

</style>
